<div class="store-editor" dir="rtl">

  <header class="store-editor__head">
    <h2 class="store-editor__title">{{ onboarding ? 'המנוי הופעל — ברוכים הבאים לחשבון העסקי' : 'פרופיל העסק שלי' }}</h2>
    <p class="store-editor__lead">
      כמנויי VIP אתם מוצגים כעסק בכל המודעות. כאן אפשר להגדיר זהות עסקית — שם, לוגו,
      תחומי פעילות ואזורי שירות — שתופיע על המודעות ובעמוד העסק. לא חובה.
    </p>
    @if (onboarding) {
      <button type="button" class="store-btn store-btn--text" (click)="skipOnboarding()">דלג, אגדיר אחר כך</button>
    }
  </header>

  @if (status?.state === 'GRACE') {
    <div class="store-alert store-alert--warn" role="status">
      המנוי הסתיים. העסק מוצג עד {{ status?.grace_until | date:'dd/MM/yyyy' }} ולאחר מכן החשבון יחזור לחשבון רגיל.
      הפרטים נשמרים ויחזרו עם חידוש.
      <a [routerLink]="['/personal/vip-subscription']">לחידוש המנוי</a>
    </div>
  }

  @if (loading) {
    <div class="store-editor__state"><div class="store-spinner"></div></div>
  } @else if (vipChecked && !isVip) {
    <!-- SCRUM-116 follow-up: store is VIP-only -->
    <div class="store-vip-gate">
      <i class="fas fa-crown"></i>
      <h3>חנות זמינה למנויי VIP</h3>
      <p>שדרגו למנוי VIP כדי לפתוח חנות עם מיתוג, לוגו ותיאור שיופיעו על המודעות שלכם ובפרופיל הציבורי.</p>
      <a [routerLink]="['/personal/vip-subscription']" class="store-btn">שדרג למנוי VIP</a>
    </div>
  } @else {

    @if (error) { <div class="store-alert store-alert--error" role="alert">{{ error }}</div> }
    @if (success) { <div class="store-alert store-alert--ok" role="status">{{ success }}</div> }

    <form class="store-form" (ngSubmit)="save()">
      <fieldset class="store-fieldset" [disabled]="readOnly">

      <!-- logo -->
      <div class="store-logo-row">
        <div class="store-logo">
          @if (shownLogo) {
            <img [src]="shownLogo" alt="לוגו החנות" />
          } @else {
            <span class="store-logo__initials">{{ initials }}</span>
          }
        </div>
        <div class="store-logo-row__actions">
          <label class="store-btn store-btn--ghost">
            בחר לוגו
            <input type="file" hidden accept="image/png,image/jpeg,image/webp"
                   (change)="onLogoPicked($event)" />
          </label>
          @if (logoPreview) {
            <button type="button" class="store-btn store-btn--text" (click)="clearPickedLogo()">
              בטל בחירה
            </button>
          }
          <p class="store-hint">PNG, JPEG או WEBP · עד 2MB</p>
          @if (logoError) { <p class="store-field-error">{{ logoError }}</p> }
        </div>
      </div>

      <!-- name -->
      <label class="store-field">
        <span class="store-field__label">שם החנות / העסק <b>*</b></span>
        <input class="store-input" type="text" [(ngModel)]="name" name="name"
               [maxlength]="nameMaxLength" required
               placeholder="לדוגמה: מוסך אבו חסן" />
      </label>

      <!-- subtitle -->
      <label class="store-field">
        <span class="store-field__label">כותרת משנה</span>
        <input class="store-input" type="text" [(ngModel)]="subtitle" name="subtitle"
               [maxlength]="subtitleMaxLength"
               placeholder="לדוגמה: סוחר רכב מורשה" />
        <span class="store-hint">מוצג מתחת לשם החנות, בפרופיל ועל המודעות.</span>
        @if (subtitlePending) {
          <span class="store-badge store-badge--pending">ממתין לאישור — יוצג לאחר בדיקה</span>
        }
        @if (subtitleRejected) {
          <span class="store-badge store-badge--rejected">הכותרת נדחתה ואינה מוצגת</span>
        }
      </label>

      <!-- description -->
      <label class="store-field">
        <span class="store-field__label">תיאור</span>
        <textarea class="store-input store-input--area" rows="5"
                  [(ngModel)]="description" name="description"
                  [maxlength]="descriptionMaxLength"
                  placeholder="ספרו על העסק — תחומי התמחות, ותק, שעות פעילות"></textarea>
        <span class="store-hint">{{ description.length }} / {{ descriptionMaxLength }}</span>
      </label>

      <!-- contact (SCRUM-96 / 260) -->
      <div class="store-grid">
        <label class="store-field">
          <span class="store-field__label">איש קשר</span>
          <input class="store-input" type="text" [(ngModel)]="contactPerson" name="contactPerson" maxlength="100" />
        </label>
        <label class="store-field">
          <span class="store-field__label">טלפון</span>
          <input class="store-input" type="tel" dir="ltr" [(ngModel)]="phone" name="phone" maxlength="20" />
        </label>
        <label class="store-field">
          <span class="store-field__label">אתר העסק</span>
          <input class="store-input" type="text" dir="ltr" [(ngModel)]="website" name="website"
                 placeholder="www.example.co.il" />
        </label>
        <label class="store-field">
          <span class="store-field__label">עיר</span>
          <input class="store-input" type="text" [(ngModel)]="city" name="city" maxlength="100" />
        </label>
      </div>

      <!-- SCRUM-287 — business contact details on ads -->
      <div class="store-field store-contact-ads">
        <label class="store-switch">
          <input type="checkbox" [(ngModel)]="showContactInAds" name="showContactInAds" />
          <span class="store-switch__track" aria-hidden="true"></span>
          <span class="store-field__label">הצג פרטי התקשרות במודעות</span>
        </label>
        <span class="store-hint">כשהאפשרות פעילה, בכל מודעה שלך יופיע בלוק "פרטי העסק" — בעמוד המודעה ובחלון "צור קשר". כשהיא כבויה, הפנייה ממשיכה דרך האתר כמו היום.</span>
        @if (showContactInAds) {
          <div class="store-chips">
            @for (o of contactFieldOptions; track o.key) {
              <button type="button" class="store-chip" [class.store-chip--on]="isContactFieldOn(o.key)"
                      [attr.aria-pressed]="isContactFieldOn(o.key)" (click)="toggleContactField(o.key)">
                {{ o.label }}
              </button>
            }
          </div>
          @if (isContactFieldOn('phone') && !phone.trim()) {
            <span class="store-hint">כדי שהטלפון יוצג, מלאו את שדה "טלפון" למעלה.</span>
          }
        }
      </div>

      <!-- domains (SCRUM-260) -->
      <div class="store-field">
        <span class="store-field__label">תחומי פעילות</span>
        <div class="store-chips">
          @for (d of domainOptions; track d.category) {
            <button type="button" class="store-chip" [class.store-chip--on]="isDomainSelected(d.category)"
                    (click)="toggleDomain(d.category)">
              {{ d.name }}
              @if (d.requires_license) { <small>· דורש רישיון</small> }
            </button>
          }
        </div>
        <span class="store-hint">התג על כל מודעה נקבע לפי הקטגוריה שלה: נדל"ן — "מתווך", רכב — "סוחר רכב", אחר — "עסק".</span>
      </div>

      <!-- service areas -->
      <div class="store-field">
        <span class="store-field__label">אזורי שירות</span>
        <div class="store-chips">
          @for (a of serviceAreas; track a) {
            <span class="store-chip store-chip--on">{{ a }}
              <button type="button" class="store-chip__x" (click)="removeArea(a)" aria-label="הסר">×</button>
            </span>
          }
          <input class="store-input store-input--inline" type="text" [(ngModel)]="areaDraft" name="areaDraft"
                 placeholder="הוסיפו עיר או אזור ולחצו Enter" (keydown.enter)="$event.preventDefault(); addArea()"
                 (blur)="addArea()" />
        </div>
      </div>

      <!-- business id + license (SCRUM-260 / 261) -->
      <div class="store-grid">
        <label class="store-field">
          <span class="store-field__label">ח.פ. / עוסק מורשה</span>
          <input class="store-input" type="text" dir="ltr" inputmode="numeric" [(ngModel)]="businessId"
                 name="businessId" maxlength="9" />
          <span class="store-hint">לא חובה. לא מוצג לציבור.</span>
        </label>
        <label class="store-field">
          <span class="store-field__label">
            מספר רישיון @if (regulatedSelected) { <b>*</b> }
          </span>
          <input class="store-input" type="text" dir="ltr" [(ngModel)]="licenseNumber" name="licenseNumber"
                 maxlength="50" />
          @if (regulatedSelected) {
            <span class="store-hint">בתחום שבחרתם נדרש רישיון (למשל רישיון תיווך במקרקעין).</span>
          }
          @switch (licenseStatus) {
            @case ('PENDING') { <span class="store-badge store-badge--pending">ממתין לבדיקת צוות האתר</span> }
            @case ('VERIFIED') { <span class="store-badge store-badge--ok">{{ store?.verified_text || 'הרישיון אומת' }}</span> }
            @case ('CORRECTION') {
              <span class="store-badge store-badge--rejected">נדרש תיקון: {{ store?.license_note }}</span>
            }
          }
        </label>
      </div>
      @if (licenseNumber.trim()) {
        <label class="store-field">
          <span class="store-field__label">סוג רישיון</span>
          <select class="store-input" [(ngModel)]="licenseType" name="licenseType">
            <option value="">אוטומטי לפי התחום</option>
            <option value="REAL_ESTATE_BROKER">רישיון תיווך במקרקעין</option>
            <option value="CAR_DEALER">רישיון סוחר רכב</option>
            <option value="OTHER">אחר</option>
          </select>
          <span class="store-hint">הזנת רישיון לא מעניקה תג "מאומת" — התג ניתן רק אחרי בדיקה. שינוי פרטים מאומתים מחזיר אותם לבדיקה.</span>
        </label>
      }
      </fieldset>

      <div class="store-actions">
        <button type="submit" class="store-btn" [disabled]="!canSave">
          {{ saving ? 'שומר…' : (hasStore ? 'שמור שינויים' : 'צור פרופיל עסקי') }}
        </button>
        @if (hasStore && !readOnly) {
          <button type="button" class="store-btn store-btn--danger"
                  [disabled]="deleting" (click)="remove()">
            {{ deleting ? 'מוחק…' : 'מחק חנות' }}
          </button>
        }
      </div>
    </form>
  }
</div>
